import { RootState } from "@/shared/types";
import { IGetManyOrdersParams, IOrdersData } from "./types/interfaces";

export const selectParams = (state: RootState): IGetManyOrdersParams =>
  state.orders.params;

export const selectOrders = (state: RootState): IOrdersData =>
  state.orders.data;
